// @flow
import * as React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import red from "@material-ui/core/colors/red";
import lightBlue from "@material-ui/core/colors/lightBlue";
import blue from "@material-ui/core/colors/blue";

type Props = {
  label: string,
  color?: "success" | "danger" | "info",
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 6,
      paddingRight: 6,
      borderRadius: 6,
      display: "inline-block",
      backgroundColor: red[50],
      color: red[500],
    },
  })
);

const COLOR_MAP = {
  success: {
    color: "#0cb376",
    backgroundColor: "rgba(12,179,118, 0.1)",
  },
  danger: {
    backgroundColor: red[50],
    color: red[500],
  },
  info: {
    backgroundColor: lightBlue[50],
    color: blue[500],
  },
};

function Label({ label, color }: Props) {
  const classes = useStyles();
  const colors = COLOR_MAP[color || "info"];
  return (
    <span className={classes.root} style={colors}>
      {label}
    </span>
  );
}

export default Label;
